import type { SessionUser } from "../../admin/session.ts";
import { isStaff } from "@divespots/contracts";
import { passkeysSupported } from "../../auth/diver-auth.ts";
import { offerDismissed } from "../../auth/passkey-offer.ts";

/**
 * Where a signed-in visitor goes: `next` when there is one, else staff to the admin area and divers
 * to the account page, which (once, and only where WebAuthn exists) offers to add a passkey.
 */
export function landingFor(user: SessionUser | null, next: string | null, locale: string): string {
  if (next) return next;
  if (!user) return `/${locale}/`;
  if (isStaff(user.role)) return `/${locale}/admin`;
  const offer = passkeysSupported() && !offerDismissed(user.id);
  return `/${locale}/konto${offer ? "?welcome=1" : ""}`;
}

/** `?next=…` for links between the auth pages, so the target survives them. */
export const nextSearch = (next: string | null): string =>
  next ? `?next=${encodeURIComponent(next)}` : "";
